import { RcFile, UploadFile } from "antd/lib/upload";
import ImageBlobReduce from "image-blob-reduce";
import Pica from "pica";

export const getFileImageDimension = (file: string | Blob | RcFile): Promise<{ width: number; height: number }> => {
	return new Promise(async (resolve) => {
		var fr = new FileReader();
		fr.onload = function () {
			var img = new Image();
			img.onload = function () {
				resolve({
					width: img.width,
					height: img.height,
				});
			};
			img.src = fr.result as string;
		};

		fr.readAsDataURL(file as File);
	});
};

export async function imageResize(
	file: File | Blob | RcFile | UploadFile<any>,
	maxWidth?: number,
	maxFileSize?: number,
	originalFileName?: string
): Promise<File | Blob | RcFile | UploadFile<any>> {
	if (!maxWidth) {
		maxWidth = 1000;
	}
	console.info("original file", file);
	const pica = Pica({ features: ["js", "wasm", "cib"] });
	console.info("pica", pica);
	const reduce = new ImageBlobReduce({ pica });
	console.info("reduce", reduce);

	let res: Blob = await reduce.toBlob(file, {
		max: maxWidth ?? 1000,
	});
	console.info("res", res);

	const resFile: File = new File(
		[res],
		(file as File).name || (file as any).name || originalFileName || "compressed_image"
	);
	console.info("resFile", resFile);

	console.info("resFile.type", resFile.type);

	if (isImageMoreThanXMB(resFile, maxFileSize ? maxFileSize : 2)) {
		console.info("resizing again... width: " + (maxWidth - 100), resFile);
		return imageResize(
			resFile,
			maxWidth - 100,
			maxFileSize,
			(file as File).name || (file as any).name || "compressed_image"
		);
	}

	return resFile;
}

export async function imageResizeWithQuality(
	file: File | Blob | RcFile | UploadFile<any>,
	maxFileSize: number = 2,
	originalFileName?: string
): Promise<File> {
	let maxWidth = 1920;
	let currentFile = file;
	let iteration = 0;
	const maxIterations = 10;

	while (isImageMoreThanXMB(currentFile, maxFileSize) && maxWidth > 200 && iteration < maxIterations) {
		const reduce = new ImageBlobReduce({ pica: Pica({ features: ["js", "wasm", "cib"] }) });

		let res: Blob = await reduce.toBlob(currentFile, {
			max: maxWidth,
			unsharpAmount: 80,
			unsharpRadius: 0.6,
			unsharpThreshold: 2,
		});

		currentFile = new File(
			[res],
			(file as File).name || (file as any).name || originalFileName || "compressed_image"
		);

		if (isImageMoreThanXMB(currentFile, maxFileSize)) {
			maxWidth = Math.floor(maxWidth * 0.9);
			console.info(`Reducing width to ${maxWidth}px, current size: ${bytesToMB(currentFile.size)}MB`);
		}
		iteration++;
	}

	return currentFile as File;
}

export function isImageMoreThanXMB(file: File | Blob | RcFile | UploadFile<any>, maxFileSize: number) {
	console.info("isImageMoreThanXMB", file);
	console.info("isImageMoreThanXMB - size", file.size);
	console.info("isImageMoreThanXMB - maxFileSize", maxFileSize);
	const res = (file.size || 0) / 1024 / 1024 > maxFileSize;
	console.info("isImageMoreThanXMB - res", res);
	return res;
}
export function bytesToMB(sizeInBytes: number) {
	return Math.ceil(sizeInBytes / 1024 / 1024);
}

export function isImage(file: File | Blob | RcFile | UploadFile<any>) {
	return (
		file.type === "image/png" ||
		file.type === "image/jpeg" ||
		(file as any).name?.toLowerCase().endsWith(".png") ||
		(file as any).name?.toLowerCase().endsWith(".jpg") ||
		(file as any).name?.toLowerCase().endsWith(".jpeg") ||
		(file as any).mimeType === "image/png" ||
		(file as any).mimeType === "image/jpeg" ||
		(file as any).originalName?.toLowerCase().endsWith(".png") ||
		(file as any).originalName?.toLowerCase().endsWith(".jpg") ||
		(file as any).originalName?.toLowerCase().endsWith(".jpeg")
	);
}

export const getBase64 = (file: File | RcFile): Promise<string> =>
	new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onload = () => resolve(reader.result as string);
		reader.onerror = (error) => reject(error);
	});

export async function fileListToBase64(fileList: any[]): Promise<string[]> {
	// here will be array of promisified functions
	const promises = [];

	// loop through fileList with for loop
	for (let i = 0; i < fileList.length; i++) {
		const file = getFile(fileList[i]);
		if (file) {
			promises.push(getBase64(file));
		} else {
			promises.push(
				new Promise((resolve) => {
					resolve(fileList[i].url as string);
				})
			);
		}
	}

	// array with base64 strings
	return (await Promise.all(promises)) as string[];
}

export function getFile(newFile: any) {
	if (isImage(newFile) && (newFile as any).originFileObj) {
		return (newFile as any).originFileObj;
	} else {
		return null;
	}
}

export function isPhotoDataOK(item: any) {
	if (typeof item === "object") {
		if (item?.error) {
			return false;
		} else {
			return true;
		}
	} else {
		return false;
	}
}
